import { Component, OnInit } from '@angular/core';

import { FormGroup, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';

import { NotificationService } from 'src/app/Service/notification.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { Router, ActivatedRoute } from '@angular/router';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';

import * as XLSX from 'xlsx';

declare let $: any

@Component({

  selector: 'app-performance-date-rent',

  templateUrl: './performance-date-rent.component.html',

  styleUrls: ['./performance-date-rent.component.css']

})

export class PerformanceDateRentComponent implements OnInit {

  lst_Report: any[] = [];

  lst_Search: any[] = [];

  bRentDetail: boolean = false;

  obj_RentAnalysis: any = {};

  obj_Report = {

    iRentCount: 0, // تعداد کل اجاره 

    strRentTime: 0, // سرجمع مدت اجاره 

    iCost: 0, // سرجمع مبلغ اجاره 

    iDamageCost: 0, // سرجمع مبلغ خسارت 

    iTotalCost: 0, // سرجمع مبلغ کل 

    fKm: 0 // سرجمع پیمایش 

  }

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iRent: new FormControl(''),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private _ARoute: ActivatedRoute

  ) { }

  ngOnInit(): void {

    this._ARoute.url.subscribe((segment: any) => {

      if (segment[0].path == 'rental-details') {

        this.bRentDetail = true;

      }

    })

  }

  exportexcel(id: any): void {

    let element = document.getElementById(`${id}`);

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const FILENAME = this.bRentDetail ? 'جزئیات اجاره' : 'عملکرد به تفکیک تاریخ';

    XLSX.writeFile(wb, `${FILENAME}.xlsx`);

  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el.strDayName?.includes(val.value) ||

        el.iDeviceCount?.toString().includes(val.value) ||

        el.strMobile_strFullName?.toString().includes(val.value) ||

        el.strFullName?.toString().includes(val.value) ||

        el.strRent_Date?.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }

    // محاسبه مجدد سرجمع ها

    this.obj_Report = {

      iRentCount: 0, // تعداد کل اجاره 

      strRentTime: 0, // سرجمع مدت اجاره 

      iCost: 0, // سرجمع مبلغ اجاره 

      iDamageCost: 0, // سرجمع مبلغ خسارت 

      iTotalCost: 0, // سرجمع مبلغ کل 

      fKm: 0 // سرجمع پیمایش 

    }

    this.lst_Report.forEach((el: any) => {

      this.obj_Report.iRentCount += el.iRentCount; // تعداد کل اجاره 

      this.obj_Report.strRentTime += el.iRentTime; // سرجمع مدت اجاره 

      this.obj_Report.iCost += el.iCost; // سرجمع مبلغ اجاره 

      this.obj_Report.iDamageCost += el.iDamageCost; // سرجمع مبلغ خسارت 

      this.obj_Report.iTotalCost += el.iTotalCost; // سرجمع مبلغ کل 

      this.obj_Report.fKm += el.fKm; // سرجمع پیمایش 

    })

  }

  async search_Report() {

    this.obj_Report = {

      iRentCount: 0, // تعداد کل اجاره 

      strRentTime: 0, // سرجمع مدت اجاره 

      iCost: 0, // سرجمع مبلغ اجاره 

      iDamageCost: 0, // سرجمع مبلغ خسارت 

      iTotalCost: 0, // سرجمع مبلغ کل 

      fKm: 0 // سرجمع پیمایش 

    }

    if (this.mdl_Search.invalid) return this._tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    this._otherService.Showspinner();

    const URL_ENDPOINT = this.bRentDetail ? 'Rent_Report_Rent_Detail' : 'Rent_Report_Rent';

    let res = JSON.parse((await axios.post(URL_ENDPOINT, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Report = res;

    this.lst_Search = res;

    this.lst_Report.forEach((el: any) => {

      this.obj_Report.iRentCount += el.iRentCount; // تعداد کل اجاره 

      this.obj_Report.strRentTime += el.iRentTime; // سرجمع مدت اجاره 

      this.obj_Report.iCost += el.iCost; // سرجمع مبلغ اجاره 

      this.obj_Report.iDamageCost += el.iDamageCost; // سرجمع مبلغ خسارت 

      this.obj_Report.iTotalCost += el.iTotalCost; // سرجمع مبلغ کل 

      this.obj_Report.fKm += el.fKm; // سرجمع پیمایش 

    })

  }

  format_Time(minutes: number): string {

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${this.padZero(hours)}:${this.padZero(remainingMinutes)}`;

  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  async openInfo(item: any) {

    this._otherService.Showspinner();

    const URL_ENDPOINT = this.bRentDetail ? 'Rent_Info' : '';

    this.mdl_Search.get('iRent')?.setValue(item.iRent)

    let res = JSON.parse((await axios.post(URL_ENDPOINT, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.obj_RentAnalysis = res[0];

    $("#RentInfo_Modal").modal('show');

  }

  showRoute(item: any) {

    window.open(`route/${item.strUnitID}`, '_blank')

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(item.strReturn_Date));

    window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strRent_Time));

    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(item.strReturn_Time));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(item.strUnitID.toString()));

    window.localStorage.setItem("carName", this.gurdService.encrypt(item.strMobile_strFullName.toString()));

    // window.localStorage.setItem("plate", this.gurdService.encrypt(item.strVehicleNo?.toString()));

  }


}
